import axios from "axios";
import { API_URL } from "../../utils/constants";

const getEmployersByWebsite = async (payload) => {
  const { data } = await axios.get(
    `${API_URL}/v1/client/employersbywebsite?page=${payload.page}&website=${payload.website}`,
    {
      headers: {
        token: process.env.REACT_APP_DOCLIB_API_TOKEN,
      },
    }
  );

  return data.results;
};

const getEmployerDetails = async (payload) => {
  const { data } = await axios.get(
    `${API_URL}/v1/client/employersdetails?employerIdForURL=${payload.employerIdForURL}&page=${payload.page}`,
    {
      headers: {
        token: process.env.REACT_APP_DOCLIB_API_TOKEN,
      },
    }
  );

  const formatDocuments = (doc) => ({
    docDescription: doc.docDescription,
    docType: doc.docType,
    docURL: doc.docURL,
    documentId: doc.sk,
    documentName: doc.docName,
    planType: doc.planType,
    displaySection: doc.displaySection,
  });

  const formatPlans = (plan) => ({
    planData: plan.planData,
    planDesc: plan.planDesc,
    planUniqueId: plan.sk,
    searchAvailable: plan.searchAvailable,
    searchDistribution: plan.searchDistribution,
    searchEnroll: plan.searchEnroll,
    showSPD: plan.showSPD,
    universalPlanValue: plan.universalPlanValue,
    showPayrollDates: plan.showPayrollDates,
    label: plan.plan_type_label,
    code: plan.planType,
  });

  const formatApprovedVendors = (vendor) => {
    return {
      vendorName: vendor.sk.split("_")[1],
      display_name: vendor.display_name,
      roth_accepted: vendor.roth_accepted,
      notes: vendor.notes,
      webSite: vendor.webSite,
      establishAccount: vendor.establishAccount,
      phoneNumber: vendor.phoneNumber,
      planType: vendor.planType,
      planPassword: vendor.planPassword,
    };
  };

  return {
    employerInfo: {
      employerName: data.results.employer.employer_name,
      state: data.results.employer.state,
    },
    plans: data.results.plans.map(formatPlans),
    approvedVendors: data.results.vendors.map((v) => formatApprovedVendors(v)),
    ...(payload.page === "formSearch" && {
      documents: data.results.documents.map(formatDocuments),
      planGroups: data.results.planGroup,
    }),
    payroll_dates: data.results.payroll_dates,
    logo: data.results.logo,
  };
};

const employerService = {
  getEmployersByWebsite,
  getEmployerDetails,
};

export default employerService;
